import axios from "axios";
import { base_url, headers } from "../constants";

// ---------- Autocomplete stock search API
export const searchStockName = async (query) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    const market = sessionStorage.getItem("selectedMarket") ?? "US";

    try {
        const response = await axios.get(`${base_url}/api/v1/stocks/search`, {
            params: { q: query, market },
            headers: {
                ...headers,
                Authorization: `Bearer ${jwtToken}`,
            },
            withCredentials: false,
        });

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401)
            return { success: false, authExpired: true };

        console.error("Stock autocomplete error:", error);
        return { success: false, error };
    }
};

// ---------- Analyst Collections
export const analystCollections = async (collection) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    const market = sessionStorage.getItem("selectedMarket") ?? "US";

    try {

        const response = await axios.get(
            `${base_url}/analyst-picks/${collection}`,
            {
                params: { market_code: market },
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );
        console.log(response);
        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Stock autocomplete error:", error);
        return { success: false, error };
    }
};

// ---------- Analyst Collections Names
export const analystCollectionNames = async (collection) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    const market = sessionStorage.getItem("selectedMarket") ?? "US";

    try {
        const response = await axios.get(
            `${base_url}/analyst-picks`,
            {
                params: { market_code: market },
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );
        console.log(response);
        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Stock autocomplete error:", error);
        return { success: false, error };
    }
};

// ---------- Top Stocks
export const getTopStocks = async ({
    page,
    page_size,
    sort_by,
    sort_order,
} = {}) => {
    const jwtToken = sessionStorage.getItem("authToken");

    try {
        const response = await axios.get(`${base_url}/api/v1/stocks`, {
            params: {
                page,
                page_size,
                sort_by,
                sort_order,
            },
            headers: {
                ...headers,
                Authorization: `Bearer ${jwtToken}`,
            },
        });

        return { success: true, data: response.data };
    } catch (error) {
        console.error("Stocks list error:", error);
        return { success: false, error };
    }
};

// ---------- Single Stock Details
export const getStockByTicker = async (ticker) => {
    if (!ticker) {
        return { success: false, error: "Ticker is required" };
    }

    const jwtToken = sessionStorage.getItem("authToken");

    try {
        const response = await axios.get(
            `${base_url}/api/v1/stocks/${ticker}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );
        console.log(response);
        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error(`Stock details error (${ticker}):`, error);
        return { success: false, error };
    }
};

// ---------- Stocks screener or list
export const getStocksScreenerQuant = async ({
    page = 1,
    page_size = 20,
    sort_by,
    sort_order = "desc",
    filters = {},
} = {}) => {
    const jwtToken = sessionStorage.getItem("authToken");

    const params = new URLSearchParams({
        page,
        page_size,
    });

    if (sort_by) params.append("sort_by", sort_by);
    if (sort_order) params.append("sort_order", sort_order);

    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length) {
            params.append(key, value.join(","));
        } else if (value) {
            params.append(key, value);
        }
    });

    try {
        const response = await axios.get(
            `${base_url}/api/v1/stocks?${params.toString()}`,
            {
                headers: {
                    ...headers,
                    token: jwtToken,
                },
                withCredentials: false,
            }
        );
        console.log(response);
        return response.data?.success
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error("Stocks list error:", error);
        return { success: false, error };
    }
};

// ---------- Get Recently Viewed (CLEAR ALL)
export const getRecentlyViewed = async () => {
    const jwtToken = sessionStorage.getItem("authToken");

    const market = sessionStorage.getItem("selectedMarket") ?? "US";
    try {
        const response = await axios.get(
            `${base_url}/api/v1/users/recently-viewed`,
            {
                params: { market_code: market },
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );

        return {
            success: true,
            data: response.data || [],
        };
    } catch (error) {
        console.error("Get recently viewed error:", error);
        return { success: false, error };
    }
};

// ---------- Recently Viewed
export const addRecentlyViewed = async (ticker) => {
    if (!ticker) {
        return { success: false, error: "Ticker is required" };
    }

    const jwtToken = sessionStorage.getItem("authToken");

    try {
        const response = await axios.post(
            `${base_url}/api/v1/users/recently-viewed/${ticker}`,
            null,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );
        console.log(response);
        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        console.error(`Stock details error (${ticker}):`, error);
        return { success: false, error };
    }
};

// ---------- Recently Viewed (CLEAR ALL)
export const clearRecentlyViewed = async () => {
    const jwtToken = sessionStorage.getItem("authToken");

    try {
        const response = await axios.delete(
            `${base_url}/api/v1/users/recently-viewed`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );

        // 204 = success (no content)
        if (response.status === 204 || response.status === 200) {
            return { success: true };
        }

        return { success: false };
    } catch (error) {
        console.error("Clear recently viewed error:", error);
        return { success: false, error };
    }
};

// ---------- Remove ticker from Recently Viewed
export const removeTickerfromRecentlyViewed = async (ticker) => {
    const jwtToken = sessionStorage.getItem("authToken");

    try {
        const response = await axios.delete(
            `${base_url}/api/v1/users/recently-viewed/${ticker}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );

        // 204 = success (no content)
        if (response.status === 204 || response.status === 200) {
            return { success: true };
        }

        return { success: false };
    } catch (error) {
        console.error("Clear recently viewed error:", error);
        return { success: false, error };
    }
};

// ---------- Get News
export const getNews = async (ticker, page = 1, page_size = 5) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const params = new URLSearchParams({
            page,
            page_size,
        });

        let url = `${base_url}/api/v1/news`;

        // 👉 ONLY use /tickers endpoint if ticker exists
        if (ticker) {
            params.append("tickers", ticker);
            url = `${base_url}/api/v1/news/tickers`;
        }

        const response = await axios.get(
            `${url}?${params.toString()}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };

    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Get news error:", error);
        return { success: false, error };
    }
};

// ---------- Get Indices Graph
export const getStocksGraph = async (ticker, period) => {
    const jwtToken = sessionStorage.getItem("authToken");

    try {
        const response = await axios.get(
            `${base_url}/api/v1/earnings/api/v1/stocks/${ticker}/chart?period=${period}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );

        if (response.status === 200) {
            return { success: true, data: response.data };
        }

        return { success: false };
    } catch (error) {
        console.error("Chart fetch error:", error);
        return { success: false, error };
    }
};

// ---------- GET TRENDING STOCKS
export const getTrendingStocks = async () => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    const market = sessionStorage.getItem("selectedMarket") ?? "US";

    try {
        const response = await axios.get(`${base_url}/api/v1/stocks/trending-stocks/get`, {
            params: { market_code: market },
            headers: {
                ...headers,
                Authorization: `Bearer ${jwtToken}`,
            },
            withCredentials: false,
        });

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };

    } catch (error) {
        if (error?.response?.status === 401)
            return { success: false, authExpired: true };

        console.error("Trending stocks error:", error);
        return { success: false, error };
    }
};

// ---------- GET MARKET MOVERS
export const getMarketMovers = async () => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    const market = sessionStorage.getItem("selectedMarket") ?? "US";

    try {
        const response = await axios.get(`${base_url}/market-movers`, {
            params: { market_code: market },
            headers: {
                ...headers,
                Authorization: `Bearer ${jwtToken}`,
            },
            withCredentials: false,
        });

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };

    } catch (error) {
        if (error?.response?.status === 401)
            return { success: false, authExpired: true };

        console.error("Market movers error:", error);
        return { success: false, error };
    }
};

// ---------- GET MARKET DATA - INDICES
const market = sessionStorage.getItem("selectedMarket") ?? "US";

export const getMarketIndices = async () => {
    const jwtToken = sessionStorage.getItem("authToken");

    try {
        const response = await axios.get(
            `${base_url}/api/v1/market/indices`,
            {
                params: { market_code: market },
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };

    } catch (error) {
        console.error("Trending stocks error:", error);
        return { success: false, error };
    }
};

export const getMarketDataByCategory = async (category) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };
    try {
        const response = await axios.get(
            `${base_url}/market-data/categories/${category}`,
            {
                headers: { ...headers, Authorization: `Bearer ${jwtToken}` },
                withCredentials: false,
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        if (error?.response?.status === 401)
            return { success: false, authExpired: true };
        return { success: false, error };
    }
};

export const getHealthNarrative = async (payload) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };
    try {
        const response = await axios.post(
            `${base_url}/comparison/health-narrative`,
            payload,
            {
                headers: { ...headers, Authorization: `Bearer ${jwtToken}` },
                withCredentials: false,
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        if (error?.response?.status === 401)
            return { success: false, authExpired: true };
        return { success: false, error };
    }
};

/**
 * POST /comparison/portfolio-rating-narrative
 * Payload: { health_score, health_grade, stocks: [{ ticker, overall_score, overall_rating,
 *            valuation_grade, growth_grade, financial_profit_grade, risk_grade,
 *            momentum_grade, balance_sheet_quality_grade?, ratios }] }
 *
 * `balance_sheet_quality_grade` is optional per stock — when sent, the narrative
 * references "Balance-Sheet Quality"; when omitted, behaviour is unchanged.
 * Response: { stock_count, ai_narrative }
 */
export const getPortfolioRatingNarrative = async (payload) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };
    try {
        const response = await axios.post(
            `${base_url}/comparison/portfolio-rating-narrative`,
            payload,
            {
                headers: { ...headers, Authorization: `Bearer ${jwtToken}` },
                withCredentials: false,
            }
        );
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        if (error?.response?.status === 401)
            return { success: false, authExpired: true };
        return { success: false, error };
    }
};

// ---------- GET TOP YIELDING STOCKS
export const getTopYieldingStocks = async () => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    const market = sessionStorage.getItem("selectedMarket") ?? "US";

    try {
        const response = await axios.get(`${base_url}/api/v1/stocks/top-yielding-stocks/get`, {
            params: { market_code: market },
            headers: {
                ...headers,
                Authorization: `Bearer ${jwtToken}`,
            },
            withCredentials: false,
        });

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };

    } catch (error) {
        if (error?.response?.status === 401)
            return { success: false, authExpired: true };

        console.error("Top yielding stocks error:", error);
        return { success: false, error };
    }
};